import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import ArrowBack from '@nerdwallet/react-icon/material/ArrowBack';
import { Link, NerdWalletLogo } from '@nerdwallet/currency';
import Close from '@nerdwallet/react-icon/material/Close';
import styles from './navbar-header.module.less';

var NavbarHeader = function NavbarHeader(_ref) {
  var showBack = _ref.showBack,
      backLabel = _ref.backLabel,
      hideLogoOnMobile = _ref.hideLogoOnMobile,
      showClose = _ref.showClose,
      onBack = _ref.onBack,
      onCancel = _ref.onCancel;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navContainer
  }, showBack && /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "Back",
    className: classnames(styles.button, styles.backButton),
    onClick: onBack
  }, /*#__PURE__*/React.createElement("span", {
    className: classes('display-flex', 'align-items-center')
  }, /*#__PURE__*/React.createElement(ArrowBack, {
    size: 24
  }), backLabel && /*#__PURE__*/React.createElement(Link, {
    component: "span",
    gotham: true,
    size: 2,
    inline: true,
    className: styles.backLabel
  }, backLabel))), !hideLogoOnMobile && /*#__PURE__*/React.createElement("div", {
    className: styles.nwLogo
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/?trk=nw_gn_5.0",
    className: styles.nwLink,
    unstyled: true
  }, /*#__PURE__*/React.createElement(NerdWalletLogo, null))), showClose && /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "Close",
    className: classnames(styles.button, styles.closeButton),
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(Close, {
    size: 24
  })));
};

NavbarHeader.displayName = 'NavbarHeader';
NavbarHeader.propTypes = {
  showBack: PropTypes.bool,
  backLabel: PropTypes.string,
  hideLogoOnMobile: PropTypes.bool,
  showClose: PropTypes.bool,
  onBack: PropTypes.func,
  onCancel: PropTypes.func
};
NavbarHeader.defaultProps = {
  showBack: true,
  backLabel: '',
  hideLogoOnMobile: false,
  showClose: true,
  onBack: function onBack() {},
  onCancel: function onCancel() {}
};
export default NavbarHeader;